import {required, maxLength, requiredIf} from 'vuelidate/lib/validators'

const applicationRecovery = {
  specialityFrom: { required },
  courseNumberFrom: { required },
  expirationReason: { required },
  expirationDate: { required },
  specialityTo: { required },
  courseNumberTo: { required },
  submissionSession: { required },
  paidFormTo: { required },
}

const applicationOrganizationTransfer = {
  specialityFrom: { required },
  courseNumberFrom: { required },
  submissionSession: { required },
  organizationFrom: { required: requiredIf((application) => {
    return !application.organizationNameFrom
  }) },
  organizationNameFrom: { required: requiredIf((application) => {
      return !application?.organizationFrom?.id
    }) },
  paidFormTo: { required },
}

const applicationEducationTransfer = {
  specialityFrom: { required },
  courseNumberFrom: { required },
  group: { required },
  paidFormFrom: { required },
  specialityTo: { required },
  courseNumberTo: { required },
  paidFormTo: { required },
  educationFormTo: { required },
  educationFormFrom: { required },
}

const achievementDoc = {
  name: { required },
  series: { required },
  number: { required },
  issueDate: { required },
  issueBy: { required },
}

const educationDoc = {
  educationDocType: { required },
  series: { required },
  number: { required },
  issueDate: { required },
}

const identityCardDoc = {
  citizenship: {required},
  identityCardDocType: {
    required: requiredIf((identityCardDoc) => {
      return !identityCardDoc?.identityCardDocTypeName
    })
  },
  identityCardDocTypeName: {
    required: requiredIf((identityCardDoc) => {
      return !identityCardDoc?.identityCardDocType?.id
    })
  },
  series: {required},
  number: {required},
  issueDate: {required},
  issueBy: {required},
}

const medicalCertificateDoc = {
  series: { required },
  number: { required },
}

const militaryDoc = {
  series: { required },
  number: { required },
  issueDate: { required },
}

const trainingCertificateDoc = {
  organization: {
    required: requiredIf((trainingCertificate) => {
      return !trainingCertificate?.organizationName
    })
  },
  organizationName: {
    required: requiredIf((trainingCertificate) => {
      return !trainingCertificate?.organization?.id
    })
  },
  series: {required},
  number: {required},
  issueDate: {required}
}

export {
  applicationRecovery,
  applicationOrganizationTransfer,
  applicationEducationTransfer,
  achievementDoc,
  educationDoc,
  identityCardDoc,
  medicalCertificateDoc,
  militaryDoc,
  trainingCertificateDoc,
}
